// extracted by mini-css-extract-plugin
export default {"screen":"StartScreen_screen__kkDVw","title":"StartScreen_title__4txa4","button":"StartScreen_button__uRxzS"};